export enum KitOrderTestType {
  HEREDITARY_30 = 'hereditary 30',
  HEREDITARY_25 = 'hereditary 25',
  HEREDITARY_41 = 'hereditary 41',
  BREAST_OVARIAN_19 = 'breast ovarian 19',
  WISDOM_9 = 'wisdom 9',
  FH_5 = 'fh 5',
  FH_3 = 'fh 3',
  CARDIO_30 = 'cardio 30',
  WES = 'whole exome',
  WGS = 'whole genome',
  LCWGS = 'low coverage whole genome',
  BRCA_1_2 = 'brca 1 2',
  HEREDITARY_7 = 'hereditary 7',
  PGX_V1 = 'pgx v1',
  PGX_V3 = 'pgx v3',
  PMS_2 = 'pms2',
  ACMG_59 = 'acmg 59',
  HDR_59 = 'hdr 59',
  METABOLISM_4 = 'metabolism 4',
  COVID_19 = 'covid-19',
  COVID_19_ANTIGEN = 'covid-19 antigen',
  ESSENTIAL_CARE_KIT = 'preventive health kit',
  AOU_HDR_V1 = 'aou acmg 59',
  AOU_PGX_V1 = 'aou pgx v1',
  CHLAMYDIA_ANAL = 'chlamydia trachomatis - anal',
  CHLAMYDIA_ORAL = 'chlamydia trachomatis - oral',
  CHLAMYDIA_URINE = 'chlamydia trachomatis - urine',
  GONORRHEA_ANAL = 'neisseria gonorrhoeae - anal',
  GONORRHEA_ORAL = 'neisseria gonorrhoeae - oral',
  GONORRHEA_URINE = 'neisseria gonorrhoeae - urine',
}

export enum KitOrderStatus {
  NO_ORDER = 'no_order', // No order exists.
  ONSITE_PURCHASE = 'onsite_purchase', // Onsite kit purchased, i.e. no shipping associated with purchase
  NOT_SHIPPED = 'not_shipped', // Order placed, not shipped.
  SHIPPED_TO_HOME = 'shipped_to_home', // Order was shipped to home.
  SHIPPED_TO_HOME_FAILED = 'shipped_to_home_failed', // Order shipped to home but failed delivery.
  DELIVERED_TO_HOME = 'delivered_to_home', // Order delivered to home.
  DELIVERED_TO_HOME_ACTIVATED = 'delivered_to_home_activated', // Sample at home and client activated.
  COLLECTED_ONSITE_ACTIVATED = 'collected_onsite_activated', // Sample collected onsite and client activated.
  SHIPPED_TO_LAB = 'shipped_to_lab', // Order was shipped to lab.
  USPS_LOST_PACKAGE = 'usps_lost_package', // USPS lost the package on return, preparing to ship a new package.
  USPS_LOST_PACKAGE_NEW_KIT_SHIPPED = 'usps_lost_package_new_kit_shipped', // USPS lost the package on return, new package on its way.
  AT_LAB_SEQUENCING = 'at_lab_sequencing', // Order is at lab and is being sequenced.
  AT_LAB_SEQUENCING_KNOWN_DELAY = 'at_lab_sequencing_known_delay', // Being sequenced, but results are delayed by a known period
  AT_LAB_SEQUENCING_UNKNOWN_DELAY = 'at_lab_sequencing_unknown_delay', // Being sequenced, but results are delayed indefinitely
  AT_LAB_NOT_ACTIVATED = 'at_lab_not_activated', // Order was delivered to lab but it's not activated.
  AT_LAB_DATA_REUSE = 'at_lab_data_reuse', // Data reuse order is at lab.
  PENDING_EXTERNAL_PHYSICIAN = 'pending_external_physician', // Report release is pending on external physician approval.
  PENDING_GC_SESSION = 'pending_gc_session', // Report is ready for release but requires GC session.
  RELEASED_NOT_OPENED = 'released_not_opened', // Report is released but has not been opened by a client.
  RELEASED_AND_OPENED = 'released_opened', // Report is released and has been opened by a client.
  RERELEASED_NOT_OPENED = 'rereleased_not_opened', // Report is re-released but has not been opened by a client.
  RERELEASED_AND_OPENED = 'rereleased_opened', // # Report is re-released and has been opened by a client.
  WISDOM_ORDER = 'wisdom_order', // Wisdom order
  CANCELED_ORDER = 'canceled', // Canceled order
}

export type TReportOrderStatusType =
  | KitOrderStatus.RELEASED_NOT_OPENED
  | KitOrderStatus.RELEASED_AND_OPENED
  | KitOrderStatus.RERELEASED_NOT_OPENED
  | KitOrderStatus.RERELEASED_AND_OPENED;

export const CANCER_TEST_TYPES: KitOrderTestType[] = [
  KitOrderTestType.HEREDITARY_30,
  KitOrderTestType.HEREDITARY_25,
  KitOrderTestType.HEREDITARY_41,
  KitOrderTestType.BREAST_OVARIAN_19,
  KitOrderTestType.WISDOM_9,
  KitOrderTestType.BRCA_1_2,
  KitOrderTestType.HEREDITARY_7,
  KitOrderTestType.PMS_2,
];

export const GENETIC_TEST_TYPES: KitOrderTestType[] = [
  ...CANCER_TEST_TYPES,
  KitOrderTestType.FH_5,
  KitOrderTestType.FH_3,
  KitOrderTestType.CARDIO_30,
  KitOrderTestType.WES,
  KitOrderTestType.WGS,
  KitOrderTestType.LCWGS,
  KitOrderTestType.PGX_V1,
  KitOrderTestType.PGX_V3,
  KitOrderTestType.METABOLISM_4,
  KitOrderTestType.ACMG_59,
  KitOrderTestType.HDR_59,
  KitOrderTestType.AOU_HDR_V1,
  KitOrderTestType.AOU_PGX_V1,
];

export const COVID_TEST_TYPES: KitOrderTestType[] = [
  KitOrderTestType.COVID_19,
  KitOrderTestType.COVID_19_ANTIGEN,
];

export const ESSENTIAL_CARE_TEST_TYPES: KitOrderTestType[] = [KitOrderTestType.ESSENTIAL_CARE_KIT];

export const STI_TEST_TYPES: KitOrderTestType[] = [
  KitOrderTestType.CHLAMYDIA_ANAL,
  KitOrderTestType.CHLAMYDIA_ORAL,
  KitOrderTestType.CHLAMYDIA_URINE,
  KitOrderTestType.GONORRHEA_ANAL,
  KitOrderTestType.GONORRHEA_ORAL,
  KitOrderTestType.GONORRHEA_URINE,
];
